import { cipo } from 'cipo';
    
cipo.controller('meetingsController', 
function ($scope, $state) {
    
});
